import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';

import { SharedDirectivesModule } from '@app/shared/shared-directives.module';

import { StripeInputComponent } from './components/stripe-input/stripe-input.component';
import { PaymentMethodsNewComponent } from './components/new/payment-methods-new.component';
import { PaymentMethodsItemComponent } from './components/item/payment-methods-item.component';
import { PaymentMethodSetupComponent } from './components/setup/payment-method-setup.component';
import { PaymentsMethodsEmptyComponent } from './components/empty/payments-methods-empty.component';
import { PaymentMethodOverviewComponent } from './components/overview/payment-method-overview.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,

    TranslateModule,

    NzSpinModule,
    NzFormModule,
    NzInputModule,
    NzModalModule,
    NzRadioModule,
    NzButtonModule,
    NzDividerModule,
    NzToolTipModule,
    NzCheckboxModule,

    SharedDirectivesModule,
  ],
  declarations: [
    StripeInputComponent,
    PaymentMethodsNewComponent,
    PaymentMethodSetupComponent,
    PaymentMethodsItemComponent,
    PaymentsMethodsEmptyComponent,
    PaymentMethodOverviewComponent,
  ],
  exports: [PaymentMethodSetupComponent, PaymentMethodOverviewComponent],
})
export class PaymentMethodsModule {}
